export type StickyVersionsState =
	| 'no-config'
	| 'no-sticky-config'
	| 'latest-expired'
	| 'expired'
	| 'latest-requested'
	| 'latest-preloaded'
	| 'latest-preload-outdated'
	| 'latest-force'
	| 'sticky'
	| 'other';

export type StickyVersionsPayloadState = StickyVersionsState | 'na';

declare global {
	interface Window {
		__SSR_STICKY_VERSION_STATE__?: StickyVersionsState;
	}
}

export const getStickyVersionsState = (): StickyVersionsPayloadState =>
	typeof window === 'undefined' ? 'na' : (window.__SSR_STICKY_VERSION_STATE__ ?? 'na');
